<template>
  <b-button
    :disabled="loading"
    :type="type"
    :variant="variant"
    :block="block"
    :to="to"
    @click="$emit('click')"
  >
    <svg
      version="1.1"
      class="loading-icon-btn"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="15px"
      height="15px"
      viewBox="0 0 50 50"
      style="enable-background: new 0 0 50 50"
      xml:space="preserve"
      v-if="loading"
    >
      <path
        fill="#fff"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
    <slot />
  </b-button>
</template>
<script>
export default {
  props: {
    block: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'default'
    },
    to: Object
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.loading-icon-btn {
  display: inline-block;
  margin-right: 10px;
}
@include media-breakpoint-down(sm) {
  .loading-icon-btn {
    margin-right: 0;
  }
}
</style>
